// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Card__card___ZsRow {
    overflow: hidden;

    height: 0;
    min-height: 100%;

    border: var(--control-border-width) solid var(--color-bg-border);
    border-radius: var(--control-radius);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Footer/Card/Card.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;;IAEhB,SAAS;IACT,gBAAgB;;IAEhB,gEAAgE;IAChE,oCAAoC;AACxC","sourcesContent":[".card {\n    overflow: hidden;\n\n    height: 0;\n    min-height: 100%;\n\n    border: var(--control-border-width) solid var(--color-bg-border);\n    border-radius: var(--control-radius);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Card__card___ZsRow`
};
export default ___CSS_LOADER_EXPORT___;
